import css from './NewsComponent.module.scss';
import parse from 'html-react-parser';
import { navigateV2 } from '../../../../../../common/utils/router';
import { svgSprite } from '../../../../../../hybrid/wrappers';
import NewsImage from '../../../../../../widgets/newsImage/NewsImage';

export default function NewsComponent({ data, key }) {
    return (
        <div onClick={() => navigateV2(`/news/${data.id}`)} className={css.newsComponent} key={key}>
            <div className={css.newsImage}>
                <NewsImage item={data} />
            </div>
            <div className={css.newsContent}>
                <p className={css.newsTitle}>{data.title}</p>
                <p className={css.newsInfo}>{parse((data.text || '')?.slice(0, 500) + '...')}</p>
                <div className={css.newsBottom}>
                    <div className={css.newsDateWrapper}>
                        <div className={css.newsDateIcon}>{svgSprite('calendar-news')}</div>
                        <p className={css.newsDate}>{data.created_at}</p>
                    </div>
                    <div className={css.newsLine}></div>
                    <div className={css.newsCategories}>
                        {data.categories.map((cat) => (
                            <div className={css.newsCategory} key={cat.id}>
                                <div className={css.newsCategoryCircle}></div>
                                <p className={css.newsCategoryName}>{cat.title}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
